// src/pages/tienda/NoticiaDetalle.js
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../utils/api';
import Breadcrumb from '../../components/Breadcrumb';
import ShareButtons from '../../components/ShareButtons';

// Renderizar contenido con imágenes y videos
function renderContenido(texto) {
  if (!texto) return null;
  const partes = texto.split(/(\!\[imagen\]\([^)]+\)|\[VIDEO:[^\]]+\])/g);
  return partes.map((parte, i) => {
    // Imagen: ![imagen](url)
    const imgMatch = parte.match(/\!\[imagen\]\(([^)]+)\)/);
    if (imgMatch) return (
      <img key={i} src={imgMatch[1]} alt="imagen" style={{ width:'100%', borderRadius:12, margin:'16px 0', maxHeight:400, objectFit:'cover' }} onError={e=>e.target.style.display='none'} />
    );
    // Video: [VIDEO:url]
    const vidMatch = parte.match(/\[VIDEO:([^\]]+)\]/);
    if (vidMatch) {
      const url = vidMatch[1];
      const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
      if (ytMatch) return (
        <div key={i} style={{ margin:'16px 0', borderRadius:12, overflow:'hidden', aspectRatio:'16/9' }}>
          <iframe width="100%" height="100%" src={'https://www.youtube.com/embed/' + ytMatch[1]} frameBorder="0" allowFullScreen style={{ display:'block' }} />
        </div>
      );
      return (
        <video key={i} src={url} controls style={{ width:'100%', borderRadius:12, margin:'16px 0' }} />
      );
    }
    // Texto normal
    return <span key={i} style={{ whiteSpace:'pre-wrap' }}>{parte}</span>;
  });
}

export default function NoticiaDetalle() {
  const { slug } = useParams();
  const [noticia, setNoticia] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/noticias/${slug}`).then(r => setNoticia(r.data)).catch(()=>{}).finally(()=>setLoading(false));
  }, [slug]);

  if (loading) return <div style={{ padding:80, textAlign:'center' }}><div className="spinner" /></div>;
  if (!noticia) return (
    <div style={{ padding:80, textAlign:'center' }}>
      <h2 style={{ fontFamily:'Playfair Display,serif', color:'#1e401f' }}>Noticia no encontrada</h2>
      <Link to="/noticias" style={{ color:'#2c5e2e', fontWeight:700 }}>Volver a noticias</Link>
    </div>
  );

  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Noticias', href:'/noticias' }, { label:noticia.titulo }]} />
      <div style={{ maxWidth:800, margin:'0 auto', padding:'60px 24px' }}>
        {noticia.categoria && <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:1.5, color:'#9FBE6A', marginBottom:16 }}>{noticia.categoria}</div>}
        <h1 style={{ fontFamily:'Playfair Display,serif', fontSize:40, color:'#1e401f', lineHeight:1.2, marginBottom:16 }}>{noticia.titulo}</h1>
        <div style={{ fontSize:13, color:'#9FBE6A', fontWeight:700, marginBottom:32 }}>{new Date(noticia.created_at).toLocaleDateString('es-CO', { year:'numeric', month:'long', day:'numeric' })}</div>

        {noticia.imagen_url && (
          <img src={noticia.imagen_url} alt={noticia.titulo} style={{ width:'100%', height:400, objectFit:'cover', borderRadius:16, marginBottom:36 }} />
        )}

        {noticia.resumen && <p style={{ fontSize:18, color:'#4a7c4c', lineHeight:1.7, marginBottom:32, fontWeight:500, borderLeft:'4px solid #9FBE6A', paddingLeft:20 }}>{noticia.resumen}</p>}

        <div style={{ fontSize:16, color:'#4a5b4a', lineHeight:1.9, whiteSpace:'pre-wrap' }}>{renderContenido(noticia.contenido)}</div>
        <ShareButtons url={'/noticias/' + noticia.slug} titulo={noticia.titulo} descripcion={noticia.resumen} imagen={noticia.imagen_url} />

        <div style={{ marginTop:48, paddingTop:32, borderTop:'1px solid rgba(44,94,46,0.1)' }}>
          <Link to="/noticias" style={{ color:'#2c5e2e', fontWeight:700, textDecoration:'none', display:'inline-flex', alignItems:'center', gap:6 }}>
            ← Volver a noticias
          </Link>
        </div>
      </div>
    </div>
  );
}
